import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { apiSlice } from "../api/apiSlice";
import dataWranglerReducer, { dwListenerMiddleware } from '../features/data-wrangler/dataWranglerSlice';
import globusReducer, { globusListenerMiddleware } from '../features/data-wrangler/globusSlice';
import ducReducer from '../features/duc/ducSlice';
import globusMessageReducer from '../reducers/globusMessageSlice'
import dashboardSlice from '../features/dashboard/dashboardSlice';
import sidebarReducer from '../components/navigation/sidebarSlice';
import publicationSlice from "../features/publications/publicationSlice";
import notificationSlice from "../features/common/notificationSlice";
import databaseSlice, { databaseListenerMiddleware } from "../features/common/databaseSlice";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        dataWrangler: dataWranglerReducer,
        globus: globusReducer,
        duc: ducReducer,
        dashboard: dashboardSlice,
        globusMessage: globusMessageReducer,
        sidebar: sidebarReducer,
        publication: publicationSlice,
        notification: notificationSlice,
        database: databaseSlice,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                // Suppresses error of unserializable regex that never changes.
                ignoredPaths: ['publication.forms'],
            }
        })
            .concat(apiSlice.middleware)
            .prepend(
                dwListenerMiddleware.middleware,
                globusListenerMiddleware.middleware,
                databaseListenerMiddleware.middleware,
            ),

    devTools: true
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
